/**
 * KB.Article.View.js
 *
 * View for the ext-kb-article page type (CMS-page rendering).
 * Receives article data from the settings record (customrecord_kb_article)
 * via options.pageInfo when a CMS page of this type exists.
 */
define('KB.Article.View', [
    'kb_article_detail.tpl',
    'KB.Icons',
    'Backbone',
    'jQuery'
], function (
    articleDetailTemplate,
    KBIcons,
    Backbone,
    jQuery
) {
    'use strict';

    function pad2(n) {
        n = Number(n) || 0;
        return (n < 10 ? '0' : '') + n;
    }

    return Backbone.View.extend({
        template: articleDetailTemplate,

        events: {
            'click .kb-article-body a[href^="#"]': 'handleAnchorScroll'
        },

        initialize: function (options) {
            this.application = options.application;

            var pageInfo = options.pageInfo || {};
            if (pageInfo instanceof Backbone.Model) {
                pageInfo = pageInfo.toJSON();
            }
            var fields = pageInfo.fields || pageInfo;

            this.articleData = {
                title: fields.name || '',
                content: fields.custrecord_kb_article_content || '',
                question: fields.custrecord_kb_article_question || '',
                typeId: String(fields.custrecord_kb_article_type || ''),
                topicId: fields.custrecord_kb_article_topic || '',
                slug: fields.custrecord_kb_article_slug || '',
                sort: fields.custrecord_kb_article_sort || 0,
                topicName: '',
                topicSlug: '',
                topicIcon: ''
            };
        },

        getTitle: function () {
            return (this.articleData.title || 'Article') + ' | Resources';
        },

        getBreadcrumb: function () {
            var crumbs = [
                { text: 'Home', href: '/' },
                { text: 'Resources', href: '/resources' }
            ];
            if (this.articleData.topicName) {
                crumbs.push({
                    text: this.articleData.topicName,
                    href: '/resources/topic/' + this.articleData.topicSlug
                });
            }
            crumbs.push({ text: this.articleData.title });
            return crumbs;
        },

        getContext: function () {
            var a = this.articleData;
            var isFaq = a.typeId === '1';
            return {
                isArticle: true,
                isList: false,
                title: a.title,
                content: a.content,
                question: a.question,
                isFaq: isFaq,
                topicName: a.topicName,
                topicSlug: a.topicSlug,
                topicIconSvg: KBIcons.get(a.topicIcon, 'kb-svg'),
                slug: a.slug,
                articleRef: (isFaq ? 'Q' : 'A') + pad2(a.sort || 1),
                arrowLeftSvg: KBIcons.get('arrowLeft', 'kb-svg'),
                arrowRightSvg: KBIcons.get('arrowRight', 'kb-svg')
            };
        },

        // In-page TOC anchor scroll — SCS otherwise routes "#kb-s3" to "/kb-s3" and 404s.
        handleAnchorScroll: function (e) {
            var a = e.currentTarget;
            var href = a && a.getAttribute('href');
            if (!href || href === '#' || href.length < 2) return;

            var targetId = href.substring(1);
            var target = document.getElementById(targetId);
            if (!target) return;

            e.preventDefault();
            e.stopPropagation();
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();

            target.scrollIntoView({ behavior: 'smooth', block: 'start' });

            try {
                if (history && history.replaceState) {
                    history.replaceState(null, '', window.location.pathname + href);
                }
            } catch (err) { /* old browser — no-op */ }
        }
    });
});
